import React from 'react';
import PropTypes from 'prop-types';
import closeBtn from '../close-btn.svg';
import { injectIntl } from 'react-intl';
import { getMessages } from '../../../tppServices/translations/messages';


// import get from 'lodash/get';
// import { isValidUsZipCode } from '@dmm/lib-common/lib/validation';

const LocatorHeader = ({ oemTerm, closeModal, intl }) => {
  const { formatMessage: t } = intl;
  const messages = getMessages();
  const CloseBtn = () => (
    <button className="close-btn" onClick={closeModal}>
      <img src={closeBtn} />
      <span className="visuallyhidden">Close Modal</span>
    </button>
  );

  // const [validZipCode, setValidZipCode] = useState(true);
  // const handleChange = (e) => {
  //   const { value: zipCode } = e.target;
  //   setValidZipCode(zipCode.length > 0 ? isValidUsZipCode(zipCode) : true);
  // };
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const postalCode = get(e, 'target.postalCode.value', '').trim();
  //   /* istanbul ignore next */
  //   if (validZipCode && postalCode.length > 0) {
  //     await fetchDealers(postalCode);
  //   } else {
  //     setValidZipCode(false);
  //   }
  // };

  return (
    <header>
      <h2>{t(messages.dealerLocatorModal.headerTitle, { oemTerm })}</h2>
      <CloseBtn />
      {/* <form onSubmit={handleSubmit}>
        <div className="input-container">
          <input
            type="text"
            maxLength={5}
            name="postalCode"
            aria-label="postalCode"
            onChange={handleChange}
            defaultValue={inputPostalCode}
            placeholder="ZIP Code (US Only)"
            className={!validZipCode ? 'error' : undefined}
          />
          {!validZipCode && (
            <ul className="zipcode-error">
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  fill="currentColor"
                  className="bi bi-exclamation-circle"
                  viewBox="0 -3 22 15"
                >
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                  <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
                </svg>
                Invalid 5 Digit US Zip Code
              </li>
              <i className="fas fa-circle" />
            </ul>
          )}
        </div>
        <button type="submit">Search</button>
      </form> */}
    </header>
  );
};

LocatorHeader.propTypes = {
  oemTerm: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  fetchDealers: PropTypes.func,
  inputPostalCode: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(LocatorHeader);
